import React from "react";
import Navbar from "../components/layout/header/Navbar";
import Footer from "../components/layout/footer/Footer";
import Refund from "../components/others/Refund";

export default function RefundPolicy() {
  return (
    <div>
      <Navbar />
      <Refund />
      <Footer />
    </div>
  );
}
